import React from "react";
import { useParams } from "react-router-dom";
import FinalReportPage from "./FinalReport";

const FinalReportPrintView = () => {
  const { candidateId } = useParams();

  if (!candidateId) {
    return (
      <div style={{ padding: "20px", textAlign: "center", fontFamily: "Arial, sans-serif" }}>
        <h3>Error: Candidate ID is missing from print URL.</h3>
      </div>
    );
  }

  return (
    <div
      style={{
        margin: 0,
        padding: 0,
        backgroundColor: "#ffffff",
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center"
      }}
    >
      <FinalReportPage candidateId={candidateId} />
    </div>
  );
};

export default FinalReportPrintView;